import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import appConfig from '../../application-config';

Vue.use(Vuex)
Vue.use(VueResource)

export const store = new Vuex.Store({
  state: {
    stateLoaded: false,
    galleryImageData: [],
    highResolution: false,
    canUseWebP: false,
    randomImages: {
      one: '',
      two: '',
      three: ''
    },
    routerLinks: [
      {
        'path': '/',
        'label': 'Home'
      },
      {
        'path': '/gallery',
        'label': 'Gallery'
      },
      // {
      //   'path': '/prices',
      //   'label': 'Prices'
      // },
      {
        'path': '/contact',
        'label': 'Contact'
      }
      // {
      //   'path': '/blog',
      //   'label': 'Blog'
      // }
    ]
  },

  mutations: {

    /**
     * Set the stateLoaded flag accordingly
     *
     * @param {Object}  state Vuex state object
     * @param {Boolean} isSet True/false indicating if the state has loaded
     */
    setStateLoaded (state, isSet) {
      state.stateLoaded = isSet
    },

    /**
     * Store the gallery images data array
     *
     * @param {Object} state         Vuex state object
     * @param {Array}  galleryImages Array of gallery image
     *
     * @returns {null}
     */
    storeGalleryImageData (state, galleryImages) {
      state.galleryImageData = galleryImages
    },

    /**
     * Set ID for random image in specific slot
     *
     * @param {Object} state       Vuex state object
     * @param {int}    randomImage The ID of the random image being set (1, 2 or 3)
     * @param {int}    imageId     The IF of the image being saved into the random image slot with ID specified above
     *
     * @returns {null}
     */
    setRandomImage (state, {randomImage, imageId}) {
      switch (randomImage) {
        case 1:
          state.randomImages.one = state.galleryImageData[imageId]
          break

        case 2:
          state.randomImages.two = state.galleryImageData[imageId]
          break

        case 3:
          state.randomImages.three = state.galleryImageData[imageId]
          break
      }
    },

    /**
     * Set high resolution flag to indicate which images to use for thumbnails
     *
     * @param state
     * @param highResolution
     *
     * @returns {null}
     */
    setHighResolution (state, highResolution) {
      state.highResolution = highResolution
    },

    canUseWebP (state, canUseWebP) {
      state.canUseWebP = canUseWebP
    }

  },

  actions: {

    /**
     * Load the initial app state
     *
     * @param {Object} commit   Vuex commit object
     * @param {Object} dispatch Vuex dispatch object
     *
     * @returns {Promise.<void>}
     */
    async loadState ({commit, dispatch}) {
      // Get a list of images from the database. Each entry contains the URL to the image on Cloudinary
      const imagesJson = await Vue.http.get(`${appConfig.cloudFunctionsUrl}/getAllImages`)
      const images = await imagesJson.json()

      commit('storeGalleryImageData', images)
      commit('setStateLoaded', true)
      dispatch('randomizeImages')

      // Check if the user is using a high resolution device
      const query = '(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)'
      if (matchMedia(query).matches) {
        commit('setHighResolution', true)
      }

      // Check for WebP support
      // const elem = document.createElement('canvas')
      // if (elem.getContext && elem.getContext('2d')) {
      //   commit('canUseWebP', elem.toDataURL('image/webp').indexOf('data:image/webp') === 0)
      // } else {
      //   commit('canUseWebP', false)
      // }
    },

    /**
     * Select random images
     *
     * @returns {null}
     */
    randomizeImages ({commit, state}) {
      const selectedIds = []

      if (!state.stateLoaded) {
        return null
      }

      /**
       * Select a random ID from the galleryImageData set
       *
       * @returns {number}
       */
      const randomImage = () => {
        const id = Math.floor(Math.random() * state.galleryImageData.length)

        if (selectedIds.indexOf(id) >= 0 || state.galleryImageData[id].isFeaturable === '0') {
          return randomImage()
        }

        selectedIds.push(id)
        return id
      }

      commit('setRandomImage', {randomImage: 1, imageId: randomImage()})
      commit('setRandomImage', {randomImage: 2, imageId: randomImage()})
      commit('setRandomImage', {randomImage: 3, imageId: randomImage()})
    }
  },

  getters: {
    canUseWebP: state => {
      return state.canUseWebP
    }
  }
})



// WEBPACK FOOTER //
// ./src/services/Store.js